import ReflectionCell from './ReflectionCell';
import style from './Legend.scss';
import { QUESTION_GROKKED } from '../../constants';
import { Icon } from 'edrolo-style-guide';

const Legend = (props) => {
  const legendItems = [
    { REFLECTION: 'Understands', GROKKED: QUESTION_GROKKED.YES, ANSWER: null },
    {
      REFLECTION: 'Understands',
      GROKKED: QUESTION_GROKKED.YES,
      ANSWER: 'Correct',
    },
    {
      REFLECTION: 'Understands',
      GROKKED: QUESTION_GROKKED.YES,
      ANSWER: 'Incorrect',
    },
    {
      REFLECTION: 'Multiple choice answer',
      GROKKED: QUESTION_GROKKED.NO_RESPONSE,
      ANSWER: null,
    },
    { REFLECTION: 'Needs help', GROKKED: QUESTION_GROKKED.NO, ANSWER: null },
    {
      REFLECTION: 'Needs help',
      GROKKED: QUESTION_GROKKED.NO,
      ANSWER: 'Correct',
    },
    {
      REFLECTION: 'Needs help',
      GROKKED: QUESTION_GROKKED.NO,
      ANSWER: 'Incorrect',
    },

    {
      REFLECTION: 'Multiple choices selected',
      GROKKED: QUESTION_GROKKED.NO_RESPONSE,
      ANSWER: null,
    },
    {
      REFLECTION: "Student hasn't reflected",
      GROKKED: QUESTION_GROKKED.NO_RESPONSE,
      ANSWER: null,
    },
  ];

  return (
    <>
      <h4 className={style.legendTitle}>Legend</h4>

      <div className={style.legend}>
        {legendItems.map((col, index) => {
          const getStudentAnswer = () => {
            if (col.REFLECTION === 'Multiple choice answer') {
              return 'B';
            }
            if (col.REFLECTION === 'Multiple choices selected') {
              return <Icon name="overflow" />;
            }
            return null;
          };

          const getBorder = () => {
            if (col.REFLECTION === 'Multiple choice answer') {
              return false;
            }
            if (col.REFLECTION === 'Multiple choices selected') {
              return false;
            }
            return true;
          };
          const isBorder = getBorder();

          return (
            <div key={index} className={style.legendItem}>
              <ReflectionCell
                className={style.smallCell}
                grokked={col.GROKKED}
                isCorrect={col.ANSWER === 'Correct'}
                isIncorrect={col.ANSWER === 'Incorrect'}
                studentAnswer={getStudentAnswer()}
                isBorder={isBorder}
              />

              <div className={style.flexSpace}>
                <div>
                  <span className={style.labelLegend}>
                    {!!col.GROKKED && 'Self reflection: '}
                  </span>

                  <span>{col.REFLECTION}</span>
                </div>

                <div>
                  {!!col.ANSWER && (
                    <div>
                      <span className={style.labelLegend}>{'Answer: '}</span>
                      <span>{col.ANSWER}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Legend;
